import React, { useState } from 'react';
import { Button, Modal, Form, Row, Col } from 'react-bootstrap';

interface VehiclePart {
  id: number;
  name: string;
  partNo: string;
  createdBy: string;
  createdAt: string;
  comment?: string;
  partSource?: string;
  partYear?: number;
  partCondition?: string;
  serialNo?: string;
  warrantyPeriod?: number;
  price?: number;
}

interface AddPartModalProps {
  show: boolean;
  onHide: () => void;
  part: VehiclePart;
  onSave: (part: VehiclePart) => void;
  selectedPartIds: number[];
}

const AddPartModal: React.FC<AddPartModalProps> = ({ show, onHide, part, onSave, selectedPartIds }) => {
  const [partData, setPartData] = useState<VehiclePart>({ ...part });

  const handleChange = (field: keyof VehiclePart, value: string | number) => {
    setPartData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = () => {
    onSave(partData);
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton className="text-white">
        <Modal.Title>{selectedPartIds.includes(partData.id) ? 'Edit' : 'Add'} Part: {partData.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        <Form>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Comment</Form.Label>
                <Form.Control
                  type="text"
                  value={partData.comment || ''}
                  onChange={(e) => handleChange('comment', e.target.value)}
                  placeholder="Enter comment"
                />
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label>Part Source</Form.Label>
                <Form.Control
                  type="text"
                  value={partData.partSource || ''}
                  onChange={(e) => handleChange('partSource', e.target.value)}
                  placeholder="Enter part source"
                />
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label>Part Year</Form.Label>
                <Form.Control
                  type="number"
                  value={partData.partYear || new Date().getFullYear()}
                  onChange={(e) => handleChange('partYear', parseInt(e.target.value))}
                  placeholder="Enter part year"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Condition</Form.Label>
                <Form.Control
                  type="text"
                  value={partData.partCondition || ''}
                  onChange={(e) => handleChange('partCondition', e.target.value)}
                  placeholder="Enter condition"
                />
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label>Serial No</Form.Label>
                <Form.Control
                  type="text"
                  value={partData.serialNo || ''}
                  onChange={(e) => handleChange('serialNo', e.target.value)}
                  placeholder="Enter serial number"
                />
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label>Warranty (months)</Form.Label>
                <Form.Control
                  type="number"
                  value={partData.warrantyPeriod || 0}
                  onChange={(e) => handleChange('warrantyPeriod', parseInt(e.target.value))}
                  placeholder="Enter warranty period"
                />
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label>Price (Rs.)</Form.Label>
                <Form.Control
                  type="number"
                  value={partData.price || 0}
                  onChange={(e) => handleChange('price', parseFloat(e.target.value))}
                  step="0.01"
                  placeholder="Enter price"
                />
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer className="bg-light">
        <Button variant="primary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="secondary" onClick={handleSubmit}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddPartModal;